import(/* webpackMode: "eager" */ "D:\\Aarav\\Projects\\relaxing-routine\\app\\instructors\\register\\page.tsx");
